module.exports = new __parcel__URL__("shadowelusion.21ca45dc.png").toString();